module.exports = __webpack_public_path__ + "img/Apps-Telegram-icon.e0e47475.png";